// @greenlight-spec: 15-database-schema.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { z } from 'zod';
// Coding agents Agent setup / the install wizard can surface guidance for
// (docs/28 §Agent setup, docs/20 §agent-setup exposure). Presentation
// filtering only — see docs/decisions/0031, ADR-0040.
export const ALL_AGENT_KINDS = ['claude', 'codex', 'cursor', 'copilot', 'other'];
export const AgentKindSchema = z.enum(ALL_AGENT_KINDS);
// `contact` sits after `idp` so the initial administrator the IdP step recorded
// is available to prefill, and before `summary` because naming a reachable
// administrator is a precondition of finishing (docs/27 §API). `payment` is
// the last step before finishing and applies to direct installs only
// (ADR-0078).
export const INSTALL_STEPS = [
    'org_setup',
    'infrastructure',
    'dns',
    'control_plane_https',
    'verified_url_handoff',
    'idp',
    'github_app',
    'plugin_marketplace',
    'contact',
    'payment',
    'summary',
];
/**
 * Whether an install shows and needs a step. Only `payment` depends on
 * anything: a marketplace or internal install is billed elsewhere, so the
 * wizard never offers it a card step and finishing never waits on one.
 */
export function installStepApplies(step, billingProvider) {
    return step !== 'payment' || billingProvider === 'direct';
}
export const InstallStepStatusSchema = z.enum([
    'pending',
    'running',
    'blocked',
    'failed',
    'complete',
]);
export const InstallStepStateSchema = z.object({
    status: InstallStepStatusSchema,
    started_at: z.string().datetime().optional(),
    completed_at: z.string().datetime().optional(),
    last_error: z.object({ code: z.string(), message: z.string(), at: z.string() }).optional(),
    details: z.record(z.unknown()).optional(),
});
/**
 * The administrator Shift contacts about this install's trial and subscription.
 * Required to finish the wizard, forwarded to the fleet monitor over its own
 * authenticated call, and never carried in the health report (docs/27 §API).
 */
export const InstallContactSchema = z.object({
    contact_name: z.string().trim().min(1).max(200),
    contact_email: z.string().trim().min(3).max(320).email(),
});
export const InstallationStateSchema = z.object({
    status: z.enum(['not_started', 'in_progress', 'complete', 'failed']).optional(),
    steps: z
        .object({
        org_setup: InstallStepStateSchema.optional(),
        infrastructure: InstallStepStateSchema.optional(),
        dns: InstallStepStateSchema.optional(),
        control_plane_https: InstallStepStateSchema.optional(),
        verified_url_handoff: InstallStepStateSchema.optional(),
        idp: InstallStepStateSchema.optional(),
        github_app: InstallStepStateSchema.optional(),
        plugin_marketplace: InstallStepStateSchema.optional(),
        contact: InstallStepStateSchema.optional(),
        payment: InstallStepStateSchema.optional(),
        summary: InstallStepStateSchema.optional(),
    })
        .optional(),
});
//# sourceMappingURL=install.js.map